import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const VENDORS_CONTACTS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('VENDOR_CONTACTS');
export const VENDORS_CONTACTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	VENDORS_CONTACTS_CRUD_ACTION_CONSTANTS
);
